import React, { useEffect, useState } from 'react';
import { TimePicker, Modal, Alert, Button, Typography } from 'antd';
import dayjs from 'dayjs';
import EmployeeRootList from './EmployeeRootList';

const { Text } = Typography;

const ManagerOpenItemDialog = (props) => {
  const {
    companyName,
    setStarttime,
    setEndtime,
    showOpenItemModalManager,
    setShowOpenItemModalManager,
    resources,
    selectedBookedItem,
    onAssignOpenItem,
    starttime,
    endtime,
    selectedLocation,
    navigation,
    removeBookedItem,
  } = props;

  const [selectedResource, setSelectedResource] = useState(null);

  const asDayjsTime = (value) => {
    if (!value) {
      return null;
    }

    if (dayjs.isDayjs(value)) {
      return value;
    }

    if (value instanceof Date) {
      return dayjs(value);
    }

    if (typeof value === 'string') {
      return dayjs(value, 'HH:mm');
    }

    return null;
  };

  const handleAssign = () => {
    if (selectedResource) {
      onAssignOpenItem(selectedBookedItem, selectedResource);
      setShowOpenItemModalManager(false);
      setTimeout(() => {
       
        navigation?.goBack?.();
      }, 1000);
    }
  };

  const handleStartTimeChange = (value) => {
    const formatted = value.format('HH:mm');
    setStarttime(formatted);
  };

  const handleEndTimeChange = (value) => {
    const formatted = value.format('HH:mm');
    setEndtime(formatted);
  };

  return (
    <Modal
      open={showOpenItemModalManager}
      onCancel={() => setShowOpenItemModalManager(false)}
      footer={null}
      width={600}
    >
      <div style={{ marginBottom: 16 }}>
        <Text strong>Date:</Text> {selectedBookedItem && selectedBookedItem.date?selectedBookedItem.date:''}
      </div>

      <div style={{ display: 'flex', gap: 16, marginBottom: 16 }}>
        <div>
          <Text strong>Start Time:</Text>
          <TimePicker
            format="HH:mm"
            value={asDayjsTime(starttime)}
            onChange={handleStartTimeChange}
          />
        </div>
        <div>
          <Text strong>End Time:</Text>
          <TimePicker
            format="HH:mm"
            value={asDayjsTime(endtime)}
            onChange={handleEndTimeChange}
          />
        </div>
      </div>

      <div style={{ marginBottom: 16 }}>

        <Text strong>Choose someone:</Text>
        {/* Replace with your EmployeeRootList or any list component */}
        {/* Assuming EmployeeRootList works on web and accepts similar props */}
         <EmployeeRootList
          onSelect={() => {}}
          selectedCustomer={selectedResource}
          setSelectedCustomer={setSelectedResource}
          title="Add resource"
          selectedLocation={selectedLocation}
          token={props.token}
        /> 
      </div>

      <div style={{ textAlign: 'center' }}>
        {selectedResource && (
          <Button type="primary" onClick={handleAssign} style={{ marginRight: 8 }}>
            Assign
          </Button>
        )}
        <Button danger onClick={() => removeBookedItem?.()}>
          Remove
        </Button>
      </div>
    </Modal>
  );
};

export default ManagerOpenItemDialog;
